module.exports = __webpack_public_path__ + "static/media/report_terminology.e9896f8e.svg";